"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Functions adapted from Snowplow PagePing functionality

// Set a time stamp for when the user last performed an "activity"
var activityHandler = exports.activityHandler = function activityHandler() {
  var now = new Date();
  window.__hudlUserActivityTracking.lastActivityTimestamp = now.getTime();
};

// Returns [pageXOffset, pageYOffset].
// Adapts code taken from: http://www.javascriptkit.com/javatutors/static2.shtml
// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollX#Notes
var getPageOffsets = function getPageOffsets() {
  var x = window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;

  var y = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

  return [x, y];
};

// Check the max scroll levels, updating as necessary
var updateMaxScrolls = function updateMaxScrolls() {
  var _getPageOffsets = getPageOffsets(),
      _getPageOffsets2 = _slicedToArray(_getPageOffsets, 2),
      x = _getPageOffsets2[0],
      y = _getPageOffsets2[1];

  if (x < window.__hudlUserActivityTracking.minXOffset) {
    window.__hudlUserActivityTracking.minXOffset = x;
  }
  if (x > window.__hudlUserActivityTracking.maxXOffset) {
    window.__hudlUserActivityTracking.maxXOffset = x;
  }

  if (y < window.__hudlUserActivityTracking.minYOffset) {
    window.__hudlUserActivityTracking.minYOffset = y;
  }
  if (y > window.__hudlUserActivityTracking.maxYOffset) {
    window.__hudlUserActivityTracking.maxYOffset = y;
  }
};

// "scroll" events.
var scrollHandler = exports.scrollHandler = function scrollHandler() {
  updateMaxScrolls();
  activityHandler();
};

// Quick initialization/reset of max scroll levels
var resetMaxScrolls = function resetMaxScrolls() {
  var _getPageOffsets3 = getPageOffsets(),
      _getPageOffsets4 = _slicedToArray(_getPageOffsets3, 2),
      x = _getPageOffsets4[0],
      y = _getPageOffsets4[1];

  window.__hudlUserActivityTracking.minXOffset = x;
  window.__hudlUserActivityTracking.maxXOffset = x;

  window.__hudlUserActivityTracking.minYOffset = y;
  window.__hudlUserActivityTracking.maxYOffset = y;
};

// Has user performed some sort of activity on page
var isUserActive = exports.isUserActive = function isUserActive(intervalMs) {
  var now = new Date();

  // Capture our initial scroll points
  resetMaxScrolls();

  // There was activity during the heart beat period;
  // on average, this is going to overstate the visitDuration by configHeartBeatTimer/2
  return window.__hudlUserActivityTracking.lastActivityTimestamp + intervalMs > now.getTime();
};